function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  className: "sol_svg__st0",
  d: "M64.6 237.9c2.4-2.4 5.7-3.8 9.2-3.8h317.4c5.8 0 8.7 7 4.6 11.1l-62.7 62.7c-2.4 2.4-5.7 3.8-9.2 3.8H6.5c-5.8 0-8.7-7-4.6-11.1l62.7-62.7z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "sol_svg__st1",
  d: "M64.6 3.8C67.1 1.4 70.4 0 73.8 0h317.4c5.8 0 8.7 7 4.6 11.1l-62.7 62.7c-2.4 2.4-5.7 3.8-9.2 3.8H6.5c-5.8 0-8.7-7-4.6-11.1L64.6 3.8z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "sol_svg__st2",
  d: "M333.1 120.1c-2.4-2.4-5.7-3.8-9.2-3.8H6.5c-5.8 0-8.7 7-4.6 11.1l62.7 62.7c2.4 2.4 5.7 3.8 9.2 3.8h317.4c5.8 0 8.7-7 4.6-11.1l-62.7-62.7z"
});

function SvgSol(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 397.7 311.7",
    width: 46,
    height: 36
  }, props), _ref, _ref2, _ref3);
}

export default __webpack_public_path__ + "ebfa2dfc018e81ab22b1e5a2b960b5f3.svg";
export { SvgSol as ReactComponent };